import React, { useEffect } from "react"
import { useState } from "react"
import { useResolveQueryStepsQuery } from "store/api/kyc/kyc"
import PhoneVerificationIcon from "../../../assets/images/icons/phone-verification.svg"
import circle from "../../../assets/images/icons/circle.svg"
import BankDetailIcon from "../../../assets/images/icons/bank-details.svg"
import AdditionalDetailsIcon from "../../../assets/images/icons/additional-details.svg"
import IDVerificationIcon from "../../../assets/images/icons/id-verification.svg"
import SignaturePhoto from "../../../assets/images/icons/signature-and-photo.svg"
import Agreement from "../../../assets/images/icons/agreement.svg"
import CheckedFill from "../../../assets/images/icons/checked-filled.svg"
import AuthorityLetter from "../../../assets/images/icons/authority-letter.svg"
import AuthorisedSignatoryIcon from "../../../assets/images/icons/authorised-signatory-kyc.svg"
import { useSelector } from "react-redux"

const originalSteps = [
  {
    label: "Phone Verification",
    key: "PHONE_VERIFICATION",
    icon: PhoneVerificationIcon,
  },
  {
    label: "Proof of Identity",
    key: "PAN_GST",
    icon: IDVerificationIcon,
  },
  {
    label: "Additional Details",
    key: "BUSINESS_ADDITIONAL_DETAILS",
    icon: AdditionalDetailsIcon,
  },
  {
    label: "Bank Verification",
    key: "BANK_VERIFICATION",
    icon: BankDetailIcon,
  },
  {
    label: "Demat Verification",
    key: "DEMAT_DETAILS",
    icon: BankDetailIcon,
  },
  {
    label: "Authorised<br/>Person KYC",
    key: "AUTHORISED_SIGNATORY",
    icon: AuthorisedSignatoryIcon,
  },
  {
    label: "Photo",
    key: "PHOTO",
    icon: SignaturePhoto,
  },
  {
    label: "Upload <br/>Authority Letter",
    key: "AUTHORITY_LETTER",
    icon: AuthorityLetter,
  },
  {
    label: "ID Verification",
    key: "ID_VERIFICATION",
    icon: IDVerificationIcon,
  },
  {
    label: "Additional Details",
    key: "ADDITIONAL_DETAILS",
    icon: AdditionalDetailsIcon,
  },
  {
    label: "Agreement Details",
    key: "AGREEMENT_DETAILS",
    icon: Agreement,
  },
]
const iconMap = originalSteps.reduce((acc, item) => {
  acc[item.key] = item.icon
  return acc
}, {})

const getIcon = (key) => iconMap[key] || null

const UpdateProfileProgressBar = ({ updateSteps = [], currentStep }) => {
  const { user, userType } = useSelector((state) => state.user)
  const [steps, setSteps] = useState([])

  useEffect(() => {
    if (updateSteps) {
      let currentIndex = 0
      if (currentStep === "SUBMITTED" || currentStep === "FINAL_STEP") {
        currentIndex = updateSteps.length - 1
      } else {
        currentIndex = updateSteps.findIndex(
          (step) => step.key && step.key.includes(currentStep)
        )
      }

      const updatedSteps = updateSteps.reduce((acc, item, index, arr) => {
        acc.push({
          ...item,
          stepNo: index + 1,
          type: "step",
          icon: getIcon(item.key),
        })

        const isLastStep = index === arr.length - 1
        if (!isLastStep) {
          if (index >= 0 && index < currentIndex) {
            acc.push({ icon: CheckedFill })
          } else {
            acc.push({ icon: circle })
          }
        }

        return acc
      }, [])

      setSteps([...updatedSteps])
    }
  }, [updateSteps, currentStep])

  return (
    <>
      <div
        className={`progress-bar-wrapper ${
          updateSteps.length === 1 ? "single-step" : ""
        }`}
      >
        {steps.map((item, index) => (
          <React.Fragment key={`steps_${index}`}>
            {item.type === "step" ? (
              <div className="progress-step-wrapper">
                <div className="progress-step">
                  <img src={item.icon} alt="" />
                </div>
                <div className="step-section">
                  <p>Step {item.stepNo}</p>
                  <h5
                    dangerouslySetInnerHTML={{
                      __html: item.label,
                    }}
                  ></h5>
                </div>
              </div>
            ) : (
              <div className="progress">
                <img src={item.icon} alt="" />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>

      {/* <div className="mobile-progress-bar-wrapper">
        <div className="progress-bar-inner-box">
          <div className="progress-bar-icon">
            <img src={PhoneVerificationIcon} alt="" />
          </div>
          <div className="progress-bar-text">
            <p>Step 1</p>
            <h5>Phone Verification</h5>
          </div>
        </div>

        <div className="progress-bar-inner-box">
          <div className="progress-bar-icon">
            <img src={IDVerificationIcon} alt="" />
          </div>
        </div>
      </div> */}
    </>
  )
}

export default UpdateProfileProgressBar
